import { styled } from '@mui/material'
import { LocationContent } from 'containers/event/map/MapContainer.style'
import { media } from 'styles/responsive'

export const SearchMapLocationContent = styled(LocationContent)`
  margin-top: 0;
  max-height: none;
  ${media.minWidth.md} {
    position: sticky;
    top: 16px;
  }
`
